/* We utilize 'lazy routing' don't break it */
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { SchoolsModule } from './schools';
import { AuthGuard, SkipIfAuthenticatedGuard } from './core/security';

export const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./search').then(m => m.SearchModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard/:selectedLenderId',
    loadChildren: () => import('./lender').then(m => m.LenderModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'school-dashboard',
    loadChildren: () => import('./search').then(m => m.SearchModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'school-dashboard/:selectedSchoolId',
    loadChildren: () => import('./schools').then(m => SchoolsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'new-configurations',
    loadChildren: () => import('./new-configurations').then(m => m.NewConfigurationsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'new-configuration/:selectedLenderId',
    loadChildren: () => import('./lender').then(m => m.LenderModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./login').then(m => m.LoginModule),
    canActivate: [SkipIfAuthenticatedGuard],
    data: {
      continueToRoute: ['/dashboard'],
      idleOff: true // the idle timeout component uses this value to turn on/off the timer (it's an opt-out thing)
    }
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: '*', redirectTo: 'dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
